// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyLink_wrapper__oyfVZ","field":"CopyLink_field__jtsAL","ani":"CopyLink_ani__c3xP-"};